import React from 'react'
import PropTypes from 'prop-types'
import { Banner, Heading, Text, Hide } from 'pcln-design-system'
import { connect } from 'react-redux'

import { setOverfilteredStatus } from '../../actions/listings/actionCreators'
import { RoutingHelper } from '../../util/routingHelper'

import { BannerContainer, UpdateLink } from './OverfilteredBanner.styles'

export class OverfilteredBanner extends React.PureComponent {
  constructor(props) {
    super(props)

    this.routingHelper = new RoutingHelper()
  }

  scrollTop = () => {
    window.scrollTo(0, 0)
  }

  componentDidUpdate() {
    return this.props.overFilteredTimeStamp && this.scrollTop()
  }

  componentDidMount() {
    return this.props.overFilteredTimeStamp && this.scrollTop()
  }

  render() {
    const {
      setOverfilteredStatus,
      overFilteredTimeStamp,
      setAttributeText,
    } = this.props
    return overFilteredTimeStamp ? (
      <BannerContainer>
        <Banner
          bg={'notify.light'}
          color={'text.dark'}
          p={3}
          mt={2}
          mb={2}
          showIcon={false}
          onClose={() => setOverfilteredStatus(false)}
        >
          {setAttributeText ? (
            <Text color={'text.dark'}>
              This filter is unavailable for this itinerary at this time
            </Text>
          ) : (
            <>
              <Heading fontSize={2} color={'text.dark'}>
                Results not found, below are your previous results.
              </Heading>
              <Text color={'text.dark'}>
                Tip: try adjusting one of your active search filters.
              </Text>
              <Hide xl xxl>
                <UpdateLink
                  color={'text.dark'}
                  fontSize={1}
                  onClick={this.routingHelper.goToFilters}
                >
                  Update Filters
                </UpdateLink>
              </Hide>
            </>
          )}
        </Banner>
      </BannerContainer>
    ) : null
  }
}

OverfilteredBanner.propTypes = {
  setOverfilteredStatus: PropTypes.func,
  overFilteredTimeStamp: PropTypes.number,
  setAttributeText: PropTypes.bool,
}

export const mapStateToProps = state => ({
  overFilteredTimeStamp: state.flags.overFilteredTimeStamp,
  setAttributeText: state.flags.setAttributeText,
})

export const mapDispatchToProps = {
  setOverfilteredStatus,
}

const overfilteredBanner = connect(
  mapStateToProps,
  mapDispatchToProps
)(OverfilteredBanner)

export { overfilteredBanner as OverfilteredBannerContainer }
